import { useTranslation } from "react-i18next";
import styles from "./SpeechllectSlide.module.scss";
import clsx from "clsx";

const SpeechllectSlide = () => {
  const { t } = useTranslation();
  return (
    <div className="h-[65vh] sm:h-[50vh] w-[100%] flex flex-column justify-between mb-[40px] sm:mb-[0px] sm:items-center">
      <div
        className={clsx(
          styles.invertedDiamond,
          styles.invertedDiamond__purple,
          "ml-[auto]",
          "sm:ml-0"
        )}
      >
        {t("page.main.slider.2.firsttitle")}
      </div>
      <div
        className={clsx(styles.invertedDiamond, styles.invertedDiamond__blue)}
      >
        {t("page.main.slider.2.secondtitle")}
      </div>
    </div>
  );
};

export default SpeechllectSlide;
